import { DateTime } from "luxon";
import DEFAULT_LOCALE from "./DEFAULT_LOCALE";

type Options = {
  timeZone?: string;
  locale?: string;
};

/**
 * @deprecated Use `dateTime(date, { timeZone, locale }).format(formatString)`.
 **/
export default function format(
  date: Date,
  formatString: string,
  options: Options = {},
): string {
  const { locale = DEFAULT_LOCALE, timeZone } = options;
  let dateTime = DateTime.fromJSDate(date);

  if (timeZone) {
    dateTime = dateTime.setZone(timeZone);
  }

  return dateTime.toFormat(formatString, { locale });
}
